(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["top-bar"] && !Shopify.designMode) return;
  try {
    
    
    const swiper = new Swiper(".shopify-section--topbar__annoucement .swiper", {
        direction: "vertical",
        autoplay: true,
        loop: true, 
        speed: 200, 
    });
  

  } catch(e) { console.error(e); }
})();
})();
